const _styleToVariant = {
    AccentOne: 'primary',
    AccentTwo: 'secondary',
    Unstyled: 'tertiary',
    Gray: 'secondary'
};

export default function styleToVariant(style) {
    return _styleToVariant[style];
}
